module.exports = __webpack_public_path__ + "img/ic-warning-red.2c49e12c.svg";